import { React } from 'libs/react';
import { Else } from 'components/util/Else';
import { When } from 'components/util/When';
import { Case } from 'components/util/Case';
import { formatFieldValue } from 'helpers/Field';
import { EmptyData } from 'components/EmptyData';
import './DealAdditionalInformationPane.scss';
/**
 * @component DealAdditionalInformationPane.tsx
 * @since 1.0.0
 */
export function DealAdditionalInformationPane(props) {
    const { dataFieldGroup, deal } = props;
    return (React.createElement("div", { className: "deal-additionnal-information-pane" },
        React.createElement(When, null,
            React.createElement(Case, { is: (dataFieldGroup === null || dataFieldGroup === void 0 ? void 0 : dataFieldGroup.length) === 0 },
                React.createElement(EmptyData, { title: t('No additional information'), description: t('There is no additional information for this deal.') })),
            React.createElement(Else, null, dataFieldGroup === null || dataFieldGroup === void 0 ? void 0 : dataFieldGroup.map((fieldGroup) => fieldGroup.fields
                .filter((field) => {
                // Afficher si le champ est actif
                if (field.active !== false)
                    return true;
                // Afficher si le champ est inactif mais a une valeur
                if (field.value && field.value !== 'null' && field.value !== '{}')
                    return true;
                // Sinon cacher
                return false;
            })
                .map((field, index) => {
                var _a, _b, _c, _d, _e, _f;
                const isInactiveWithValue = field.active === false && field.value && field.value !== 'null' && field.value !== '{}';
                const fieldTitle = isInactiveWithValue ? `${field.title} (${t('Inactive')})` : field.title;
                return (React.createElement("div", { key: index },
                    React.createElement("div", { className: "deal-additional-information-pane-title" }, fieldTitle),
                    React.createElement("div", null, ((_a = deal === null || deal === void 0 ? void 0 : deal.fieldValues) === null || _a === void 0 ? void 0 : _a.find((f) => f.field.id == field.id)) ? (React.createElement("div", { className: "deal-additional-information-pane-value", dangerouslySetInnerHTML: {
                            __html: formatFieldValue((_d = (_c = (_b = deal === null || deal === void 0 ? void 0 : deal.fieldValues) === null || _b === void 0 ? void 0 : _b.find((f) => f.field.id == field.id)) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : '', field.type, field, (_e = deal === null || deal === void 0 ? void 0 : deal.language) !== null && _e !== void 0 ? _e : '', false, (_f = deal === null || deal === void 0 ? void 0 : deal.subtotal) === null || _f === void 0 ? void 0 : _f.toString())
                        } })) : (React.createElement("div", { className: "deal-additional-information-pane-value" }, t('No data'))))));
            }))))));
}
